<template>
  <template v-if="show">
    <div
      id="travel-specialist-modal"
      tabindex="-1"
      class="flex overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full"
      role="dialog"
      aria-modal="true"
      @click.self="$emit('close')"
    >
      <div class="relative p-4 w-full max-w-2xl max-h-full">
        <div class="relative bg-white rounded-xl shadow-lg">
          <div class="flex items-center justify-between rounded-t-xl h-64 overflow-hidden">
            <img :src="sellerImgBig" class="object-cover object-center w-full h-full" alt="Travel specialist">
            <button
              type="button"
              class="text-white text-sm w-8 h-8 ms-auto inline-flex absolute top-3 right-3 justify-center items-center"
              aria-label="Close modal"
              @click="$emit('close')"
            >
              <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
              </svg>
            </button>
          </div>
          <div class="p-5 md:p-10 mb:pb-12 space-y-4">
            <div class="text-center mb-2">
              <svg class="mx-auto" width="23" height="14" viewBox="0 0 23 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0.608918 8.04466L10.9311 13.8498C11.289 14.0501 11.7217 14.0501 12.0795 13.8498L22.3911 8.04466C23.203 7.58728 23.203 6.4046 22.3911 5.94723L12.0769 0.150203C11.7217 -0.0500677 11.289 -0.0500677 10.9311 0.150203L0.608918 5.94723C-0.202973 6.4046 -0.202973 7.58728 0.608918 8.04466Z" fill="#F19F00" />
              </svg>
              <h6 class="text-dark text-xl font-secondary mb-1 mt-3">{{ agentName }}</h6>
              <a :href="`mailto:${agentEmail}`" class="text-primary text-sm">{{ agentEmail }}</a>
            </div>
            <p class="text-sm text-dark opacity-70" v-html="agentDescription"></p>
            <div v-if="userVideo" class="w-full flex justify-center">
              <a class="text-sm opacity-70 text-dark italic font-bold w-full mt-4 md:mt-2 text-center cursor-pointer mb-4" :href="userVideo" target="_blank" rel="noopener noreferrer">
                {{ tr('_YTLink') }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40"></div>
  </template>
</template>

<script>
export default {
  name: 'TravelSpecialistModal',
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['close'],
  computed: {
    agentName() {
      return this.$store.state.agentName;
    },
    agentEmail() {
      return this.$store.state.agentEmail;
    },
    agentDescription() {
      return this.$store.state.agentDescription;
    },
    sellerImgBig() {
      return this.$store.state.sellerImgBig;
    },
    userVideo() {
      return this.$store.state.userVideo?.URL;
    },
  },
  methods: {
    tr(key) {
      return this.$root.tr(key);
    },
  },
};
</script>
